import { Component, inject } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FilterService } from '../../../../util/filters/filter.service';
import { CourseCatalogueAgeFilterComponent } from '../course-catalogue-filter/course-catalogue-age-filter/course-catalogue-age-filter.component';
import { CourseCataloguePeriodFilterComponent } from '../course-catalogue-filter/course-catalogue-period-filter/course-catalogue-period-filter.component';
import { CourseCatalogueThemeFilterComponent } from '../course-catalogue-filter/course-catalogue-theme-filter/course-catalogue-theme-filter.component';
import { DividerComponent } from '../../../home/divider/divider.component';
import { CourseCatalogueLocationFilterComponent } from '../course-catalogue-filter/course-catalogue-location-filter/course-catalogue-location-filter.component';
import { CourseCatalogueThemeCategoryFilterComponent } from '../course-catalogue-filter/course-catalogue-theme-category-filter/course-catalogue-theme-category-filter.component';

@Component({
  selector: 'app-courses-sidebar',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    CourseCatalogueAgeFilterComponent,
    CourseCataloguePeriodFilterComponent,
    CourseCatalogueLocationFilterComponent,
    CourseCatalogueThemeFilterComponent,
    DividerComponent,
    CourseCatalogueThemeCategoryFilterComponent,
  ],
  templateUrl: './course-catalogue-sidebar.component.html',
})
export class CourseCatalogueSidebarComponent {
  private readonly filterService = inject(FilterService);
  reset() {
    this.filterService.resetFilters();
  }
}
